import { render, staticRenderFns } from "./BaseSubmitModal.vue?vue&type=template&id=37765c10&scoped=true&"
import script from "./BaseSubmitModal.vue?vue&type=script&lang=js&"
export * from "./BaseSubmitModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseSubmitModal.vue?vue&type=style&index=0&id=37765c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37765c10",
  null
  
)

export default component.exports